<template>
  <div class="page-login">
    <div class="bg"></div>
    <div class="main">
      <div style="flex: 0 0 80px; background-color: #fff;">
        <div style="max-width: 1180px; margin: auto; line-height: 80px;">
          <span style="font-size: 22px">财政区块链电子票据</span>
          <span style="display:inline-block; width: 32px; text-align: center;">|</span>
          <span>在线管理平台</span>
        </div>
      </div>
      <div style="flex: 1;">
        <div style="max-width: 950px; margin: auto; display: flex; margin-top: 32px">
          <div style="flex: 1;">
            <img
              width="100%"
              src="../../assets/img/home.png"
            />
          </div>
          <div style="flex: 1; text-align: center;">
            <div style="
            margin: auto; width: 410px; height: 400px; border-radius: 8px; border: 1px solid #fff; background-color: #fff; box-shadow: 0 0 20px 0 rgba(14, 40, 93, .08); position: relative;">
              <div style="position: absolute; top: 8px; right: 8px; height: 48px; width: 48px; "></div>
              <div style="
              position: absolute; 
              top: 8px; right: 8px; border-style: solid; border-width: 24px 24px 24px 24px; border-color: transparent transparent #fff #fff; width: 0px; height: 0px; cursor: pointer;"></div>
              <div style="margin: auto; padding: 8px;">
                <div style="margin: 40px; margin-bottom:0;">扫码登录
                </div>

                <!-- form -->
                <div style="display:none;">
                  <el-form
                    ref="form"
                    :model="form"
                    label-width="80px"
                  >
                    <el-form-item label="用户名">
                      <el-input v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="密码">
                      <el-input v-model="form.password"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button
                        type="primary"
                        @click="onSubmit"
                      >登录</el-button>
                    </el-form-item>
                  </el-form>
                </div>

                <!-- 图片 -->
                <!--
                    -->
                <div
                  id="div_f0"
                  style="text-align: center;"
                  v-loading="imgLoading"
                >
                  <div
                    v-loading="false"
                    style="width: 220px; 
                    height:280px;
                    margin:auto; 
                    position:relative;"
                  >
                    <img
                      id="img_ewm"
                      style="width: 100%;"
                    />

                    <div
                      id="div_sx"
                      style="display: none;
                       text-align: center;"
                      @click="clickSx"
                    >
                      <div><i class="el-icon-refresh-right"></i></div>
                      <div>二维码失效,点击刷新</div>
                    </div>
                  </div><!-- /div_sx -->
                </div><!-- /div_img -->

                <!-- 1 -->
                <div
                  id="div_f1"
                  style="width: 220px; 
                    height:280px;
                    margin:auto;
                    padding-top: 40px;"
                >
                  <div>
                    <i
                      class="el-icon-success"
                      style="font-size: 90px;color: #51bd82;"
                    ></i>
                  </div>
                  <div>
                    扫码成功
                  </div>
                </div>
                <!-- 2 -->
                <div
                  id="div_f2"
                  style="width: 100%; 
                    height:280px;
                    margin:auto;
                    padding-top: 40px;"
                >
                  <div>
                    <i
                      class="el-icon-success"
                      style="font-size: 90px;color: #51bd82;"
                    ></i>
                  </div>

                  <div>
                    您暂无权限登录，进行单位入驻操作或联系管理员处理
                  </div>
                  <div>
                    <el-button
                      id="btn_rz"
                      type="primary"
                      @click="clickRz"
                    >单位入驻</el-button>
                  </div>
                  <div>
                    <a
                      href="javascript:void(0)"
                      style=""
                      @click="clickSx"
                    >重新获取二维码</a>
                  </div>
                </div>

                <!-- 3 -->
                <div
                  id="div_f3"
                  style="width: 220px; 
                    height:280px;
                    margin:auto;
                    padding-top: 40px;"
                >
                  <div>
                    <i
                      class="el-icon-error"
                      style="font-size: 90px;color: #51bd82;"
                    ></i>
                  </div>
                  <div>
                    您没有使用权限，请联系管理员
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div>
          <p>
            <span>版权所有：云南省财政厅</span>
            <span>|</span>
            <span>政务主办单位：云南省财政厅</span>
          </p>
          <p>建议您使用Chrome、360等主流浏览器访问本系统</p>
        </div>
      </div>
    </div>
    <script
      id="tpl_json"
      type="template/text"
    >
    </script>
  </div>
</template>
<script>
let _ajax_loop_able = true;
let _ajax_loop_count = 0;

let _ajax_sx = true;

export default {
  data() {
    return {
      imgLoading: true,
      key: "",
      token: "",
      form: {
        name: "",
        password: "",
      },
    };
  },
  methods: {
    ajaxGetImg() {
      this.$axios
        .post("/api?jkDm=GETQRCODEBASE64", { t: 1 })
        .then((response) => {
          console.log(response.data.returnCode, response.data);
          if (response.data.returnCode == "0000") {
            //let src = "data:image/png;base64," + response.data.data.qrcode;
            document.getElementById("img_ewm").src = response.data.data.qrcode;
            this.key = response.data.data.key;
            //console.log('---------------------------------------------------------------')
            //console.log('this.key',this.key)
            this.imgLoading = false;
            _ajax_loop_count = 0;
            this.ajaxLoop();
          }
        });
    },
    clickSx() {
      document.getElementById("div_f0").style.display = "block";
      document.getElementById("div_sx").style.display = "none";
      document.getElementById("div_f1").style.display = "none";
      document.getElementById("div_f2").style.display = "none";
      
      this.imgLoading = true;
      this.ajaxGetImg();
    },

    noLoop() {
      let div = document.getElementById("div_sx");
      div.style.display = "block";
    },

    ajaxLoop() {
      if (!_ajax_loop_able) {
        return;
      }

      if (_ajax_loop_count >= 60 * 5) {
        this.noLoop();
        return;
      }
      _ajax_loop_count++;

      let data = { key: this.key };
      console.log("data", data);
      setTimeout(() => {
        this.$axios
          .post("/api?jkDm=CHECKQRCODESCAN", data)
          .then((response) => {
            console.log(response.data.returnCode, response.data);
            if (response.data.returnCode == "0000") {
              // -1 超时未扫描
              // 0未扫码
              // 1 已扫码
              // 2  可以登录
              // 3  没有用户

              if (response.data.data.flag == "0") {
                this.ajaxLoop();
                return;
              } else if (response.data.data.flag == "-1") {
                this.noLoop();
                return;
              } else if (response.data.data.flag == "1") {
                this.handleF1();
                this.ajaxLoop();
                return;
              } else if (response.data.data.flag == "2") {
                this.handleF2(response.data.data);
                return;
              } else if (response.data.data.flag == "3") {
                this.handleF3(response.data);
                return;
              } else if (response.data.data.flag == "4") {
                this.handleF4(response.data.data);
                return;
              }
            }
          });
      }, 1000);
    },

    handleF1() {
      document.getElementById("div_f0").style.display = "none";
      document.getElementById("div_f1").style.display = "block";
      document.getElementById("div_f2").style.display = "none";
    },
    handleF2(data) {
      // 2  可以登录
      _ajax_loop_able = false;
      sessionStorage.setItem("token", data.token);
      this.$router.push("/index");
      window['userName'] = data.userName
    },
    clickRz() {
      _ajax_loop_able = false;
      sessionStorage.setItem("token", this.token);
      this.$router.push("/enter/01");
    },
    handleF3(data) {
      _ajax_loop_able = false;
      this.$message.error(data.returnMsg)
      document.getElementById("div_f0").style.display = "none";
      document.getElementById("div_f1").style.display = "none";
      document.getElementById("div_f2").style.display = "none";
      document.getElementById("div_f3").style.display = "block";
    },
    handleF4(data) {
      _ajax_loop_able = false;
      sessionStorage.setItem("token", data.token);
      this.$router.push("/index");
    },
    onSubmit() {
      
    },
  },
  mounted() {
    sessionStorage.clear();
    //*
    _ajax_loop_able = true;
    this.ajaxGetImg();
    /*/
    this.imgLoading = false;
    document.getElementById("div_f0").style.display = "none";

    //document.getElementById("div_f1").style.display = "block";

    //document.getElementById("div_f2").style.display = "block";
    //*/
  },
  destroyed() {
    _ajax_loop_able = false;
  },
};
</script>
<style scoped>
.el-container {
  height: 100%;
}
.el-header,
.el-footer {
  background-color: #b3c0d1;
  color: #333;
  text-align: center;
  line-height: 60px;
}

.el-main {
  background-color: #e9eef3;
  color: #333;
  text-align: center;
  height: calc(100% - 120px);
}

.login-panel {
  margin: auto;
  width: 320px;
}

.page-login {
  height: 100%;
  background-color: #f5f8fd;
}

.page-login .bg {
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 10;
  background: url("../../assets/img/login-bg.png") no-repeat;
  background-size: cover;
}

.page-login .main {
  height: 100%;
  width: 100%;
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
}

.page-login .footer {
  flex: 0 0 80px;
  font-size: 14px;
  color: #fff;
}

.page-login .footer > div {
  max-width: 1180px;
  margin: auto;
  border-top: 1px solid #fff;
  /*color: #999;*/
  line-height: 24px;
}
/*page-home*/
.page-home {
  background-color: #f5f8fd;
}

.page-home .main {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.page-home .main * {
  box-sizing: border-box;
}

.page-home .layout-top {
  flex: 0 0 40px;
  background-color: #fcfcfc;
  color: #666;
  display: flex;
  line-height: 40px;
  /* rgba(0,21,41,.35) */
  border-bottom: 1px solid #ccc;
  transition: all 0.1s;
}

#div_sx {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  text-align: center;
  background: hsla(0, 0%, 100%, 0.9);
  padding: 0;
  padding-top: 80px;

  cursor: pointer;
}

#div_f1,
#div_f2,
#div_f3 {
  display: none;
}

#btn_rz {
  height: 50px;
  width: 160px;
  border-radius: 22px;
}

a {
  color: #0072ff;
  font-size: 15px;
}
</style>
